import React from 'react';
import { PropTypes } from 'prop-types';

import styles from './ContentFrame.scss';

const ContentFrame = ({
  children,
  size,
  pageType,
  externalHeader,
  sidebar,
  backLink,
  hasRelativePositing,
}) => {
  const typeClass = pageType ? ` ContentFrame--${pageType}` : '';
  const widthClass = size ? ` ContentFrame--${size}` : '';
  const containerStyles = {};
  if (hasRelativePositing) containerStyles.position = 'relative';
  return (
    <div className={`ContentFrame${typeClass}${widthClass}`}>
      {backLink}
      {externalHeader}
      <div className="ContentFrame__container" style={containerStyles}>
        {sidebar
          ? [
              <div className="ContentFrame__sidebar" key="sidebar">
                {sidebar}
              </div>,
              <div className="ContentFrame__content" key="content">
                {children}
              </div>,
            ]
          : children}
      </div>
    </div>
  );
};

ContentFrame.propTypes = {
  pageType: PropTypes.oneOf([
    'transactional',
    'with-side-nav',
    'with-right-sidebar',
    'payment-with-header',
    'pricing',
    'static-modal',
    'with-graphic',
  ]),
  children: PropTypes.node,
  externalHeader: PropTypes.element,
  sidebar: PropTypes.node,
  backLink: PropTypes.element,
  hasRelativePositing: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default ContentFrame;
